<template>
  <bscroll-view>
    <div class="knowledge-book-content">
      <div class="content-body">
        <div
          v-if="knowledgeBookBg!=''"
          class="search-wrap"
          :style="{ 'background-image': `url('${knowledgeBookBg}')` }"
        >
          <!-- <div class="search-content">
                        <img src="@/assets/img/search-glass.png">
                        <input type="text" :placeholder="langTransfer('请输入内容，按回车搜索')">
                    </div> -->
        </div>
        <div class="knowledge-book-group">
          <div
            v-for="(item, i) in datalist"
            :key="i"
            class="item"
            @click="goDeteils(item)"
          >
            <img :src="item.poster" />
            <div class="name">
              {{ langTransfer(item.name) }}
            </div>
          </div>
          <div class="item hb-spacebeteen-empty" />
          <div class="item hb-spacebeteen-empty" />
          <div class="item hb-spacebeteen-empty" />
          <div class="item hb-spacebeteen-empty" />
          <div class="item hb-spacebeteen-empty" />
        </div>
      </div>
      <footer-com />
    </div>
  </bscroll-view>
</template>

<script>
import BscrollView from "@/components/bscrollView";
import FooterCom from "@/components/footerCom/footerCom";
import { readinglist } from "../../api/lyl";

// const mainBgDefault = require("@/assets/img/knowledge-book-bg.jpeg");
const mainBgDefault = "";

export default {
  name: "KnowledgeBook",
  components: {
    FooterCom,
    BscrollView,
  },
  data() {
    return {
      datalist: [],
    };
  },
  computed: {
    pageSetup() {
      return this.$store.state.pageSetup;
    },
    webInfo() {
      return this.$store.state.webInfo;
    },
    knowledgeBookBg() {
      const { upperPart } = this.$store.state;
      if (!upperPart.enableModuleList) {
        return mainBgDefault;
      }

      const result = upperPart.enableModuleList.find((e) => {
        return e.type === 3;
      });

      return result && result.poster ? result.poster : mainBgDefault;
    },
  },
  watch: {
    webInfo(newVal) {
      if (newVal.service_code) {
        this.readinglist();
      }
    },
  },
  mounted() {
    const { service_code } = this.webInfo;
    if (service_code) {
      this.readinglist();
    }
  },
  methods: {
    goDeteils(item) {
      const { href } = this.$router.resolve({
        name: "knowledgeBookRecommend",
        params: {
          id: item.unique_code,
        },
      });
      window.open(href, "_blank");
    },
    async readinglist() {
      try {
        const data = await readinglist({
          service_code: this.webInfo.service_code,
          type: "2",
        });
        this.datalist = data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 10000px) {
  .knowledge-book-group {
    width: 1296px;
    .item {
      width: 196px;
      height: 111px;
    }
  }
}
@media screen and (max-width: 1280px) {
  .knowledge-book-group {
    width: 1136px;
    .item {
      width: 169px;
      height: 96px;
    }
  }
}
.knowledge-book-content {
  width: 100%;
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.content-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.search-wrap {
  width: 100%;
  height: 360px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.search-content {
  width: 720px;
  height: 40px;
  box-sizing: border-box;
  padding: 8px 10px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #cccccc;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  img {
    width: 24px;
    height: 24px;
  }

  input {
    flex: 1;
    font-size: 13px;
    font-family: AlibabaPuHuiTiR;
    color: #606266;
  }
}

.knowledge-book-group {
  margin: 30px 0 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;

  .item {
    border-radius: 8px;
    margin-top: 20px;
    overflow: hidden;
    cursor: pointer;
    position: relative;
    transition: 0.3s;

    &:active {
      transform: scale(0.98);
    }

    &:hover {
      .name {
        background: rgba(0, 0, 0, 0.8);
      }
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }

    .name {
      font-size: 18px;
      font-family: AlibabaPuHuiTiM;
      color: #ffffff;
      line-height: 24px;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      // font-weight: 600;
      background: rgba(0, 0, 0, 0.4);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      user-select: none;
      transition: 0.3s;
    }
  }
}
</style>

<style>
.search-content input::-webkit-input-placeholder {
  /* WebKit browsers */
  font-size: 13px;
  font-family: AlibabaPuHuiTiR;
  color: #909399;
}
.search-content input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 13px;
  font-family: AlibabaPuHuiTiR;
  color: #909399;
}
.search-content input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 13px;
  font-family: AlibabaPuHuiTiR;
  color: #909399;
}
.search-content input::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  font-size: 13px;
  font-family: AlibabaPuHuiTiR;
  color: #909399;
}
</style>
